common.View.create('shop::website.modules.shopProducts.Show', {

    async onDOMLoad() {
        this.initSlider();
        this.initUpCrossSellSliders();
        this.initZoom();
        this.initAddToCart();
        this.initStockSubscription();
    },

    initSlider()
    {
        if( this.element.find('.slider .swiper-slide').length <= 1 ) {
            return;
        }

        let galleryThumbs = new Swiper(this.element.find(".thumbs").get(0), {
            spaceBetween: 10,
            navigation: {
                nextEl: this.element.find(".thumbs .swiper-button-next").get(0),
                prevEl: this.element.find(".thumbs .swiper-button-prev").get(0)
            },
            //centeredSlides: true,
            slidesPerView: "auto",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            centerInsufficientSlides: true,
            slideToClickedSlide: true
        });

        let galleryTop = new Swiper(this.element.find(".slider").get(0), {
            spaceBetween: 10,
            navigation: {
                nextEl: this.element.find(".slider .swiper-button-next").get(0),
                prevEl: this.element.find(".slider .swiper-button-prev").get(0)
            },
            thumbs: {
                swiper: galleryThumbs
            },
            on: {
                slideChange: (slide) => {
                    let activeIndex = slide.activeIndex + 1,
                        slideElement = slide.thumbs.swiper.$el[0];

                    let activeSlide = slideElement.querySelector(`.thumbs .swiper-slide:nth-child(${activeIndex})`),
                        nextSlide = slideElement.querySelector(`.thumbs .swiper-slide:nth-child(${activeIndex + 1})`),
                        prevSlide = slideElement.querySelector(`.thumbs .swiper-slide:nth-child(${activeIndex - 1})`);

                    if( !this.elementIsVisible(activeSlide, true) ) {
                        slide.thumbs.swiper.slideTo(--activeIndex);
                    } else if (nextSlide && !this.elementIsVisible(nextSlide, true)) {
                        slide.thumbs.swiper.slideNext();
                    } else if (prevSlide && !this.elementIsVisible(prevSlide, true)) {
                        slide.thumbs.swiper.slidePrev();
                    }
                }
            }
        });

        // galleryTop.controller.control = galleryThumbs;
        // galleryThumbs.controller.control = galleryTop;
    },

    elementIsVisible(el, fullVisible)
    {
        if ( el.tagName === "HTML" )
            return true;
        var parentRect = el.parentNode.getBoundingClientRect();
        var rect = arguments[2] || el.getBoundingClientRect();
        return (
            ( fullVisible ? rect.top    >= parentRect.top    : rect.bottom > parentRect.top ) &&
            ( fullVisible ? rect.left   >= parentRect.left   : rect.right  > parentRect.left ) &&
            ( fullVisible ? rect.bottom <= parentRect.bottom : rect.top    < parentRect.bottom ) &&
            ( fullVisible ? rect.right  <= parentRect.right  : rect.left   < parentRect.right ) &&
            this.elementIsVisible(el.parentNode, fullVisible, rect)
        );
    },

    initUpCrossSellSliders()
    {
        let options =  {
            spaceBetween: 30,
            slidesPerView: 1,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 4,
                }
            }
        };

        new Swiper(this.element.find(".shopProductUpsell .swiper").get(0), {
            ...options,
            navigation: {
                prevEl: this.element.find(".shopProductUpsell .swiper-button-prev").get(0),
                nextEl: this.element.find(".shopProductUpsell .swiper-button-next").get(0),
            },
        });
        new Swiper(this.element.find(".shopProductCrossSell .swiper").get(0), {
            ...options,
            navigation: {
                prevEl: this.element.find(".shopProductCrossSell .swiper-button-prev").get(0),
                nextEl: this.element.find(".shopProductCrossSell .swiper-button-next").get(0),
            },
        });
    },

    initZoom() {
        let imageZoom = setInterval(() => {

            this.element.find('.image-zoom')
                .each((key, element) => {
                    // Remove zoom (on slides)
                    //$(element).trigger('zoom.destroy');

                    if( !$(element).parents('.owl-item').hasClass('active') || $(element).find('> span').length ) {
                        return;
                    }

                    // Add (re-add) zoom
                    $(element).find('img')
                        .wrap('<span style="display:inline-block"></span>')
                        .css('display', 'block')
                        .parent()
                        .css('cursor', 'zoom-in')
                        .zoom({
                            url: $(element).data('src'),
                            on: 'click',
                            magnify: 1.3,
                        });
                });

            clearInterval(imageZoom);

        }, 500);
    },

    initAddToCart() {
        this.element

            // Listen to add to cart button click.
            .find('button[name="addToCart"]:enabled')
                .click(this.onAddToCartClick.bind(this))
                .end();
    },

    async onAddToCartClick() {
        // TODO Low: Enable and fix the 'flash' once the next requests executes super fast?
        // Swal.showLoading();

        this.element.find('button[name="addToCart"]').addClass('loading');

        // Request
        let response = await $.post(document.location.pathname + '/add-to-cart', {
            'amount': this.element.find('[name="amount"]').val()
        });

        // Show alert message
        $('.shop\\:\\:website-modules-shopProducts-show-Quantity')
            .html(response.infoMessagesView);

        if( response.hasOwnProperty('success') && !response.success ) {
            this.element.find('button[name="addToCart"]').removeClass('loading').addClass('failed');
        } else {
            // Update amount in header.
            $('.website\\:\\:layouts-main-Header').data('instance')
                .setTotalPhysicalAmount(response.totalPhysicalAmount);

            // Update mini cart
            $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance')
                .replaceMiniCart(response.miniCartView, false);

            // Add clicked class on button
            this.element.find('button[name="addToCart"]').removeClass('loading').addClass('clicked');
        }

        // Remove clicked after x seconds
        setTimeout(() => {
            this.element.find('button[name="addToCart"]')
                .removeClass('failed')
                .removeClass('clicked');
        }, 2000);

        // TODO Medium: Style
        // Navigate to checkout?
        // if ((await Swal.fire({
        //     title: 'Toegevoegd',
        //     text: 'Het product is toegevoegd aan je winkelwagen.',
        //     icon: 'successs',
        //     showCancelButton: true,
        //     cancelButtonColor: '#707070',
        //     cancelButtonText: 'Verder winkelen',
        //     confirmButtonColor: '#4a7729',
        //     confirmButtonText: 'Nu afrekenen'
        // })).value)
        //     document.location.href = this.element.data('checkout-url');
    },

    initStockSubscription() {
        this.element

            .find('.stockSubscription')

            // Listen for enters on input.
            .find('input')
            .keydown(e => {
                if (e.code == 'Enter')
                    this.subscribeOnStock();
            })
            .end()

            // Listen for button click?
            .find('button')
            .click(this.subscribeOnStock.bind(this))
            .end();
    },

    // TODO Low: Implement error handler with notification for every request initiated by an user?
    async subscribeOnStock() {
        // Abort due to no email given?
        let email = this.element.find('.stockSubscription input').val();

        if (!email)
            return;

        // Request
        let response = await $.post(document.location.pathname + '/subscribe-to-stock', {email});

        // Notify
        await Swal.fire({
            title: 'Ingeschreven',
            text: 'Je bent succesvol ingeschreven om een melding te ontvangen wanneer het product terug beschikbaar is.',
            icon: 'success',
            confirmButtonColor: '#4a7729',
            confirmButtonText: 'Sluit'
        });
    },

});
